import React from 'react';
import Modal from '../Modal';

const ModifyDateModal = ({
  visible,
  title,
  dateFields = [],

  onSave,
  onCancel,

  cancelLabel = 'INDIETRO',
  saveLabel = 'SALVA',

  showFooter = true,
  renderFooter
}) => {

  const renderModalBody = () => (
    <div>
      {dateFields.map((field) => (
        <div className="input-wrapper" key={field.name}>
          <label className="label" htmlFor={field.name}>
            {field.label}
          </label>
          <input
            type="date"
            className="input"
            id={field.name}
            name={field.name}
            value={field.value}
            min={field.min}
            max={field.max}
            onChange={(e) => field.onChange(e.target.value)}
          />
        </div>
      ))}
    </div>
  )

  const renderModalFooter = () => {
    if (!showFooter) return null;

    if (renderFooter) {
      return renderFooter({ onSave, onCancel });
    }

    const hasCancel = typeof onCancel === 'function';
    const hasSave = typeof onSave === 'function';

    if (!hasCancel && !hasSave) return null;

    return (
      <div className="button-container">
        {hasCancel && (
          <button
            className="button button--secondary"
            onClick={onCancel}
          >
            {cancelLabel}
          </button>
        )}
        {hasSave && (
          <button
            className="button button--primary"
            onClick={onSave}
          >
            {saveLabel}
          </button>
        )}
      </div>
    );
  };

  return (
    <Modal
      visible={visible}
      title={title}
    >
      {renderModalBody()}
      {renderModalFooter()}
    </Modal>
  );
}

export default ModifyDateModal;